import { View } from 'tamagui'
import { CoverImage } from '@components/CoverImage'
import { HeroIcon } from '@components/HeroIcon'

interface IVideoThumbnailProps {
  thumbnailUrl?: string
  title: string
  onPlayPress: () => void
  playButtonSize: number
  playPauseLabel: string
}

export function VideoThumbnail({
  thumbnailUrl,
  title,
  onPlayPress,
  playButtonSize,
  playPauseLabel,
}: IVideoThumbnailProps) {
  return (
    <View
      position="absolute"
      width="100%"
      height="100%"
      zIndex={3}
      backgroundColor="$cross-black"
      justifyContent="center"
      alignItems="center"
    >
      <View
        onPress={onPlayPress}
        role="button"
        aria-label={playPauseLabel}
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
        position="absolute"
        flex={1}
        zIndex={4}
        borderRadius="$border-radius-pill"
        padding="$spacing-inset-xxs"
      >
        <HeroIcon
          icon={['fas', 'play']}
          size={playButtonSize}
          color="$text-on-media"
        />
      </View>
      <View
        position="absolute"
        width="100%"
        height="100%"
        zIndex={3}
        backgroundColor="rgba(0, 0, 0, 0.7)"
      />
      {thumbnailUrl && (
        <CoverImage
          uri={thumbnailUrl}
          width="100%"
          height="100%"
          objectFit="fill"
          eager
          alt={title}
          fadeDuration={0}
        />
      )}
    </View>
  )
}
